import {React, useState, useEffect} from 'react';


import "@fontsource/mulish"; // Defaults to weight 400.



import { Routes ,Route } from 'react-router-dom';

import Home from './Home';
import Admin from './Admin';
import AppHeader from './AppHeader';

import Button from '@mui/material/Button';

import {getConfigValue} from './Config';

import { makeStyles } from '@mui/styles';


const useStyles = makeStyles(theme => ({   
    
  supportButtonRow: {
      fontFamily:'Mulish', 
      display: 'flex', 
      flexDirection: 'row',         
      justifyContent: 'flex-end', 
      alignItems: 'flex-center',
      //margin: '10px',
      // marginLeft: '.5em',
      marginTop: '.1em',       
      //backgroundColor:'#F3F3F3',
      // padding: '.5em',
      // paddingTop:'1em',
      width:'100%',
      borderRadius: '3px',
      fontSize: '9pt',
     

  },
}));

function Main() {
  const [sessionToken, setSessionToken] = useState();
  const [isLoggedIn, setIsLoggedIn] = useState(false); //for UX, security is all on the server side
  const [isAdmin, setIsAdmin] = useState(false);  //for UX, security is all on the server side
  const [userName, setUserName] = useState('');
  const [adminRoles, setAdminRoles] = useState([]);
  const [aadEmail, setAadEmail] = useState();
 
  const classes = useStyles();

  var store = require('store')



  const clickedSupport = async () => { 
    const res = await fetch(`${getConfigValue('serverBaseUrl')}/api/Home/createSupportIssue/${store.get("sessionToken")}`);            
        const json = await res.json();   
               
                 
        if (json["result"]=='success' && json['supportId']) {                        
            window.open(`https://bos.service-now.com/bos?id=sc_cat_item_new_ux_public&sys_id=e6bd8a2c1b9e511068b7a713604bcb29&sysparm_fakturahotell_guid=${json['supportId']}`, '_blank');            
           

        }
  }

  const checkLoginStatus = async () => { 
    fetchSessionToken();
  }


  useEffect(() =>  { //run once, first time to get a token
    fetchSessionToken();  
        
    
  },[])

  const fetchSessionToken = async () => {    
    
    const res = await fetch(`${getConfigValue('serverBaseUrl')}/api/Home/getSessionToken/${store.get("sessionToken")}`); //sessionToken will be renewed if necessary    
    const json = await res.json(); 

    //debug
    //console.log("sessionData: ", json);

    store.set("sessionToken", json["sessionToken"]);
    

     //debug
     console.log("base url ", `${getConfigValue('serverBaseUrl')}/api/Home/getSessionToken/${store.get("sessionToken")}`);
  
    //security is all on the server side, no api calls will be processed if not logged in on the server    
    if (json["isLoggedIn"]) {

      setIsLoggedIn(true);       
      
      if (json['userName']) {
        setUserName(json['userName']); 
      }

      setIsAdmin(json["isAdmin"]);  

      setAdminRoles(json['adminRoles']);

      setAadEmail(json['aadEmail']);  
      

    }
   
   

  };

  return (  

    
    
    <div>
      <AppHeader isLoggedIn={isLoggedIn} setLoggedIn={setIsLoggedIn} userName={userName} backButton={false} title={"InvoiceHotel"}/>

      {isLoggedIn && 
        <div className={classes.supportButtonRow}>
          <Button style={{marginRight:'3px'}}  variant="contained" color="primary" size='small' onClick={clickedSupport}   >
              Support                    
          </Button> 
        </div> 
      }

      <Routes>  
        <Route path="/" element={<Home checkLoginStatus={checkLoginStatus} isLoggedIn={isLoggedIn} />} />

        <Route path="/xadmin" element={<Admin checkLoginStatus={checkLoginStatus} isLoggedIn={isLoggedIn} userName={userName} isAdmin={isAdmin} adminRoles={adminRoles} aadEmail={aadEmail}/>} />
        
      </Routes>
      
       

    </div>

    

  );
}






export default Main;
